import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'react-intl';

// helpers
import tracking from 'dibs-tracking';
import { isEmailOnly } from 'dibs-cookie-jar/src/helpers/emailOnlyHelpers';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';
import { getInvoiceHref } from '../helpers/getInvoiceHref';
import get from 'lodash.get';

function onInvoiceClick({ event, user, invoiceLink }) {
    event.preventDefault();
    const isFullAccount = !get(user, 'authMetadata.emailOnly');
    const hasEmailToken = isEmailOnly(document.cookie);
    if (hasEmailToken) {
        const email = get(user, 'profile.email');
        authModalLoader
            .show({
                action: isFullAccount
                    ? authModalLoader.constants.LOGIN
                    : authModalLoader.constants.FORGOT_PASSWORD,
                flow: isFullAccount
                    ? authModalLoader.constants.LOGIN_EMAIL_TOKEN_VIEW_INVOICE_FLOW
                    : authModalLoader.constants.CREATE_PASSWORD_INVOICE_FLOW,
                email,
            })
            .then(({ userId }) => {
                if (userId) {
                    window.location.href = invoiceLink;
                }
            });
    } else {
        window.location.href = invoiceLink;
    }
    tracking.trackEvent({
        category: 'product',
        action: 'view invoice',
        label: 'pdp description',
    });
}

export function PdpSharedDetailItemInvoiceComponent({ itemId, skuId, user }) {
    const invoiceLink = getInvoiceHref(itemId, skuId);
    return (
        <span data-tn="pdp-spec-item-invoice">
            <FormattedMessage
                id="pdpDetails.invoiceText"
                defaultMessage="Generate an invoice that you can customize and print."
            />
            <div>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={event => onInvoiceClick({ event, user, invoiceLink })}
                >
                    <FormattedMessage id="pdpDetails.invoiceLink" defaultMessage="View Invoice" />
                </a>
            </div>
        </span>
    );
}

PdpSharedDetailItemInvoiceComponent.propTypes = {
    itemId: PropTypes.string.isRequired,
    skuId: PropTypes.string,
    user: PropTypes.object,
};

export const PdpSharedDetailItemInvoice = createFragmentContainer(
    PdpSharedDetailItemInvoiceComponent,
    {
        user: graphql`
            fragment PdpSharedDetailItemInvoice_user on User {
                profile {
                    email
                }
                authMetadata {
                    emailOnly
                }
            }
        `,
    }
);
